import _ from "lodash";

import store from "@/store";
import i18n from "@/plugins/i18n";
import moment from "moment-timezone";
import router from "@/router";

import { getHelpInteraction, getUserInteraction } from "@/api/user/traits.api";

const state = {
  surveyId: false,
  firstTimeShown: false,
  chatbot: {},
  next: false,
  questions: [],
  totalelements: 0,
  totalelementsdone: 0,
  survey: {},
  bots: [
    {
      id: "kybot",
      types: ["SURVEYTYPE_KYMATIO_DIRECT"],
      name: "Kybot",
      desc: i18n.t("menu.bots.kybot.description"),
      image: "bot1.png",
      visible: true,
      service: "risk"
    },
    {
      id: "wellbot",
      types: ["SURVEYTYPE_KYMATIO_CLIMA_PLUS", "SURVEYTYPE_KYMATIO_BURNOUT"],
      name: "Wellbot",
      desc: i18n.t("menu.bots.wellbot.description"),
      image: "bot2.png",
      visible: true,
      service: "wellbeing"
    },
    {
      id: "cybot",
      types: ["SURVEYTYPE_KYMATIO_CYBERSECURITY"],
      name: "Cybot",
      desc: i18n.t("menu.bots.cybot.description"),
      image: "bot4.png",
      visible: true,
      service: "awareness"
    },
    {
      id: "supbot",
      types: ["SURVEYTYPE_KYMATIO_WELCOME"],
      name: "Supbot",
      desc: i18n.t("menu.bots.supbot.description"),
      image: "bot3.png",
      visible: true
    },
    {
      id: "breaches",
      types: ["SURVEYTYPE_KYMATIO_GAMING"],
      name: "ABS Bot",
      desc: "",
      image: "bot5.png",
      visible: false
    }
  ],
  status: ""
};

const getters = {
  isChatbotActive: state => state.status === "active",
  status: state => state.status,
  bots: state =>
    _.filter(
      state.bots,
      bot =>
        bot.service === undefined ||
        store.getters["Auth/hasModule"]([bot.service])
    ),
  bot: state => state.chatbot.bot,
  interaction: state => state.chatbot.interaction,
  isLoading: state => state.status === "loading",
  totalelements: state => state.totalelements,
  totalelementsdone: state => state.totalelementsdone,
  survey: state => state.survey,
  nextSurvey: state => state.next,
  questions: state => state.questions,
  hasBeenShown: state => state.firstTimeShown
};

const actions = {
  activate({ commit, dispatch, state, rootGetters }, params) {
    var interactions = rootGetters["User/interactions"];
    var interaction = {};
    var bot = {};
    var forceStatus = {};
    if (params.forceStatus !== undefined)
      forceStatus = { forceStatus: params.forceStatus };

    if (!params.reset || params.reset === false) {
      commit("reset");
      commit("set_loading");
    }

    // Checking what data we have and what to do with it
    if (params.bot !== false && params.bot !== "" && params.bot !== undefined) {
      bot = _.find(state.bots, b => b.id === params.bot);
    } else if (
      params.surveyEntityId !== false &&
      params.surveyEntityId !== "" &&
      params.surveyEntityId !== undefined
    ) {
      interaction = _.find(interactions, o => {
        return parseInt(o.surveyEntityId) === parseInt(params.surveyEntityId);
      });
    } else {
      interaction = _.find(interactions, o => {
        return (
          parseFloat(o.percentage) < parseFloat(100) &&
          moment().isAfter(o.userStartDate)
        );
      });
    }

    // Now fetching data from api depending on what we've got
    if (Object.keys(interaction).length > 0 && Object.keys(bot).length === 0) {
      bot = _.find(state.bots, b => {
        return _.find(b.types, type => {
          return (
            parseInt(interaction.familyTypeId) ===
            parseInt(rootGetters["Constants/getConstant"](type))
          );
        });
      });
      commit("set_chatbot", { bot: bot, interaction: interaction });
      commit("set_loading");
      if (
        interaction &&
        parseInt(interaction.familyTypeId) ===
          parseInt(
            rootGetters["Constants/getConstant"](
              "SURVEYTYPE_KYMATIO_CYBERSECURITY"
            )
          )
      ) {
        commit("reset");
        router.push({
          name: "Cybertest",
          params: { surveyEntityId: interaction.surveyEntityId }
        });
      } else {
        getUserInteraction(interaction.surveyEntityId, true).then(resp => {
          commit("set_questions", resp.data.records.questions);
          commit("set_total_elements", {
            totalelements: resp.data.records.totalelements,
            totalelementsdone: resp.data.records.totalelementsdone
          });
          commit("set_survey", resp.data.records);
          setTimeout(() => {
            commit("set_done");
          }, 500);
        });
      }
    } else if (
      Object.keys(interaction).length === 0 &&
      Object.keys(bot).length > 0
    ) {
      var nextInteraction = _.find(interactions, o => {
        return (
          parseFloat(o.percentage) < parseFloat(100) &&
          moment().isAfter(o.userStartDate)
        );
      });
      if (
        nextInteraction &&
        parseInt(nextInteraction.familyTypeId) ===
          parseInt(
            rootGetters["Constants/getConstant"]("SURVEYTYPE_KYMATIO_WELCOME")
          )
      ) {
        dispatch("activate", {
          surveyEntityId: nextInteraction.surveyEntityId,
          restart: false
        });
      } else {
        commit("set_chatbot", { bot: bot, interaction: interaction });
        commit("set_loading");
        _.forEach(bot.types, type => {
          if (state.questions.length === 0) {
            getHelpInteraction(
              rootGetters["Constants/getConstant"](type),
              true,
              forceStatus
            ).then(resp => {
              if (resp.data.records.survey) {
                commit(
                  "set_questions",
                  resp.data.records.survey.action.questions
                );
                params.next
                  ? commit("set_next", params.next)
                  : commit("set_next", resp.data.records.next);
                setTimeout(() => {
                  commit("set_done");
                }, 500);
              } else if (Object.keys(resp.data.records.next).length > 0) {
                dispatch("activate", {
                  surveyEntityId: resp.data.records.next.surveyEntityId,
                  restart: false
                });
              }
            });
          }
        });
      }
    }
  },
  firstTimeShown({ commit }) {
    commit("set_shown");
  },
  reset({ commit }) {
    commit("reset");
  },
  resetStatus({ commit }) {
    commit("reset_status");
  }
};

const mutations = {
  set_chatbot(state, data) {
    state.chatbot = data;
  },
  set_survey_id(state, data) {
    state.surveyId = data;
  },
  set_questions(state, data) {
    state.questions = data;
  },
  set_next(state, data) {
    if (data && Object.keys(data).length > 0) state.next = data;
  },
  set_bot(state, data) {
    state.bot = data;
  },
  set_loading(state) {
    state.status = "loading";
  },
  set_total_elements(state, data) {
    state.totalelements = data.totalelements;
    state.totalelementsdone = data.totalelementsdone;
  },
  set_survey(state, data) {
    state.survey = data;
  },
  set_done(state) {
    state.status = "active";
  },
  set_shown(state) {
    state.firstTimeShown = true;
  },
  set_status(state, data) {
    state.status = data;
  },
  reset(state) {
    state.surveyId = false;
    state.firstTimeShown = false;
    state.chatbot = {};
    state.status = "";
    state.next = false;
    state.questions = [];
    state.totalelements = 0;
    state.totalelementsdone = 0;
    state.survey = {};
  },
  reset_status(state) {
    state.status = "";
    state.questions = [];
    state.chatbot = {};
    state.survey = {};
    state.totalelements = 0;
    state.totalelementsdone = 0;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
